import React from "react";
import Modal from "react-bootstrap/Modal";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import ChonMaHopDong from "components/CommonComponent/ChonMaHopDong";

class ThemMoiCongViec extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text1: "",
      showChonMaHopDong: false,
    };
  }
  onChangeData = (field, event) => {
    let state = this.state;
    state[field] = event.target.value;
    this.setState(state);
  };

  setModalChonMaHopDongShow = () => {
    this.setState({
      showChonMaHopDong: !this.state.showChonMaHopDong,
    });
  };

  render() {
    let props = this.props;
    let { showChonMaHopDong } = this.state;
    return (
      <Modal
        {...props}
        size="modal-new-size modal-new-size"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left popup-detail"
      >
        <Modal.Header>
          <h4 className="modal-title" id="myModalLabel16">
            <span className="btn-icon-right">
              <i className="fas fa-plus"></i>
            </span>{" "}
            Thêm mới công việc
          </h4>
          <button
            type="button"
            className="close-popup-new"
            data-dismiss="modal"
            aria-label="Close"
            onClick={props.onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          <form className="form tat-toan form-horizontal form-edit">
            <div className="form-body">
              <div className="card collapse-icon accordion-icon-rotate">
                <div
                  id="headingCollapse196"
                  className="card-header border-info"
                  href="#collapse196"
                  aria-expanded="true"
                  aria-controls="collapse196"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Người nhận việc</h3>
                  </a>
                </div>
                <div
                  id="collapse196"
                  aria-labelledby="headingCollapse96"
                  className="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Mã công việc"
                                disabled="disabled"
                              ></TextInputOnRow>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label for="projectinput1">Nhân viên</label>
                                <select className="selectBox form-control input-sm">
                                  <option value="0">
                                    Nguyễn Thị Thu Trang
                                  </option>
                                  <option value="4">Nguyễn Văn A</option>
                                </select>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label for="projectinput1">Ngày bắt đầu</label>
                                <input
                                  type="text"
                                  className="form-control input-sm datepicker-default"
                                  name="fname"
                                />
                              </div>
                            </div>

                            <div className="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Tên công việc"
                              ></TextInputOnRow>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label>
                                  Liên quan đến hợp đồng
                                  <span className="right-text">
                                    <a
                                      href={() => false}
                                      className="blue btn-link"
                                      onClick={this.setModalChonMaHopDongShow}
                                    >
                                      chọn nhanh
                                    </a>
                                  </span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control input-sm"
                                  name="fname"
                                />
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label for="projectinput1">Ngày kết thúc</label>
                                <input
                                  type="text"
                                  className="form-control input-sm datepicker-default"
                                />
                              </div>
                            </div>

                            <div className="col-md-12">
                              <div className="form-group">
                                <label for="projectinput8">
                                  Nội dung công việc
                                </label>
                                <textarea
                                  rows="2"
                                  className="form-control input-sm"
                                  name="comment"
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  id="headingCollapse19699"
                  className="card-header border-info"
                  href="#collapse19699"
                  aria-expanded="true"
                  aria-controls="collapse19699"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Người giao việc</h3>
                  </a>
                </div>
                <div
                  id="collapse19699"
                  aria-labelledby="headingCollapse9699"
                  className="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Chức vụ</label>
                                <select className="selectBox form-control input-sm">
                                  <option value="0">Chủ</option>
                                  <option value="4">Quản lý</option>
                                </select>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label for="projectinput1">
                                  Người giao việc
                                </label>
                                <select className="selectBox form-control input-sm">
                                  <option value="0">Nguyễn Thu Hà</option>
                                  <option value="4">Nguyễn Anh Đức</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <ChonMaHopDong
            show={showChonMaHopDong}
            onHide={this.setModalChonMaHopDongShow}
          ></ChonMaHopDong>
        </Modal.Body>
        <Modal.Footer className="modal-footer button-popup-new-size">
          <a className="btn btn-new-main btn-checknew" href={() => false}>
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>{" "}
            Thêm mới
          </a>

          <a
            className="btn btn-new-main btn-closenew"
            data-dismiss="modal"
            href={() => false}
            onClick={props.onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>{" "}
            Đóng
          </a>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default ThemMoiCongViec;
